var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"side-menu-opener side-menu-closer",attrs:{"arial-label":_vm.label}},[_c('span',{domProps:{"textContent":_vm._s(_vm.label)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }